export function useDebounce() {
    function debounce(func, wait=500) {
        let timeout;

        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func(...args);
            }, wait);
        };
    }

    return {
        debounce
    }
}
